import { getInternationalPriceNuqlium, nuqliumDataIndexSeven } from './utils';

const internationalPrice = getInternationalPriceNuqlium();

export const buildNuqliumProductQuery = (input) => {
  var nuqliumQuery = {
    DataIndex: nuqliumDataIndexSeven(),
    output: 'json',
    pagetype: 'feed',
    pagekey: 'nq-product-feed-new-sevenstore-pdp',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  };

  var array = typeof input === 'string' ? JSON.parse(input) : input;

  array.forEach(function (prod, index) {
    var buildSettingsString = 'settings[products][' + index + ']';
    nuqliumQuery[buildSettingsString] = prod;
  });

  return nuqliumQuery;
};

// Monetate page view
export const sendMonetateData = (prodIdSku, prodSku) => {
  window.monetateQ = window.monetateQ || [];
  window.monetateQ.push(['setPageType', 'productReact']);
  window.monetateQ.push([
    'addProductDetails',
    [{ productId: prodIdSku, sku: prodSku }]
  ]);
  window.monetateQ.push(['trackData']);
};

// Ometria
export const ometriaInit = (prodIdSku) => {
  if (typeof ometria != 'undefined') {
    window.ometria.init('product', { pid: prodIdSku }, 'www.footasylum.com');
  }
};

export const gaDetailViewTracking = (data) => {
  const prodData = data.data.products.products[0].product;
  const gaDataObj = {
    event: 'detailView',
    eventCategory: 'Ecommerce',
    eventAction: 'Detail View',
    eventLabel: prodData.name,
    eventValue: prodData.option.promotionpriceasnumber,
    ecommerce: {
      currencyCode: data.data.pricelist.currency,
      detail: {
        actionField: { list: 'Product Page' },
        products: [
          {
            name: prodData.name,
            id: prodData.productid,
            price: prodData.option.promotionpriceasnumber,
            brand: prodData.attributes.brand[0],
            category: prodData.attributes.product_category[0],
            onSale: prodData.option.onsale ? 'Yes' : 'No',
            quantity: 1,
            variant: prodData.attributes.primarycolour[0]
          }
        ]
      }
    }
  };
  // console.log('GA detailView:', gaDataObj);
  if (typeof dataLayer != 'undefined') {
    window.dataLayer.push(gaDataObj);
  }
};

// ADD TO CART - EVENT
export const gaAddToCart = (gaAddToCartData) => {
  const prodData = gaAddToCartData.data.products.products[0].product;
  const gaDataATCObj = {
    event: 'addToCart',
    eventCategory: 'Ecommerce',
    eventAction: 'Add To Cart',
    eventLabel: prodData.name,
    eventValue: prodData.option.promotionpriceasnumber,
    ecommerce: {
      currencyCode: gaAddToCartData.data.pricelist.currency,
      detail: {
        actionField: { list: 'Product Page' },
        products: [
          {
            name: prodData.name,
            id: prodData.productid,
            price: prodData.option.promotionpriceasnumber,
            brand: prodData.attributes.brand[0],
            category: prodData.attributes.product_category[0],
            onSale: prodData.option.onsale ? 'Yes' : 'No',
            quantity: 1,
            variant: prodData.attributes.primarycolour[0]
          }
        ]
      }
    }
  };
  //console.log('GA addToCart:', gaDataATCObj);
  if (typeof dataLayer != 'undefined') {
    window.dataLayer.push(gaDataATCObj);
  }
};

export const getSkuFromUrl = (path) => {
  const pathSplit = path.split('/');
  const filtered = pathSplit.filter(function (el) {
    return el;
  });
  const getlast = filtered.slice(-1)[0];
  if (getlast) {
    const valArr = getlast.split('-');
    const seachCode = valArr.slice(-1)[0];
    return seachCode.length === 6 || seachCode.length === 7 ? seachCode : '';
  }
};

export const setUrl = (url) => {
  const getSession = (history) => {
    return window.location.search ? window.location.search : '';
  };
  window.location.hostname === 'localhost' ||
  window.location.hostname === '0.0.0.0'
    ? window.history.replaceState({}, '', '')
    : window.history.replaceState({}, '', url + getSession(window.history));
};

export const getFormData = (object) => {
  const formData = new FormData();
  Object.keys(object).forEach((key) => formData.append(key, object[key]));
  return formData;
};
